import { apiLoyaltyRules } from './apiLoyaltyRules'
import { apiLoyaltyActions } from './apiLoyaltyActions'
import { apiLoyaltyActivities } from './apiLoyaltyActivities'
import { apiLoyaltyTransation } from './apiLoyaltyTransation'
import { apiLoyaltyPoints } from './apiLoayltyPoint'
import { apiLoyaltyLevels } from './apiLoyaltyLevel'

const apiPointsGroup = {
	...apiLoyaltyRules,
	...apiLoyaltyActions,
	...apiLoyaltyActivities,
	...apiLoyaltyTransation,
	...apiLoyaltyPoints,
	...apiLoyaltyLevels,
}

export { apiPointsGroup }
